export const radii = { none: 0, sm: 4, md: 4, lg: 8, card: 4, pill: 4 } as const;

export type RadiusToken = keyof typeof radii;

export const r = (token: RadiusToken): string => `${radii[token]}px`;
